
const ProfileCompletionSection = ({ completionPercentage, onCompleteAction, t }) => (
  <div className="personal-data__completion">
    <div className="personal-data__completion-header">
      <p className="personal-data__completion-title">
        {t('personalData.profileCompletion.title', { percent: completionPercentage })}
      </p>
      {completionPercentage < 100 ? (
        <button type="button" className="personal-data__completion-action" onClick={onCompleteAction}>
          {t('personalData.profileCompletion.action')}
        </button>
      ) : null}
    </div>
    <div className="personal-data__completion-track">
      <div className="personal-data__completion-fill" style={{ width: `${completionPercentage}%` }} />
    </div>
  </div>
);

export default ProfileCompletionSection;
